export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('page:loading:start', () => {
        // setPageLayout( nuxtApp._route.path != '/login' ? 'default' :'login-layout')
    })
  })